const buildQueryBooster = (props, data) => {
  const { recencyBoostProperty } = props;

  if (!recencyBoostProperty || !recencyBoostProperty.length) return data;
  const { rawQueryStringified = '' } = data;

  const parsedRawQuery = JSON.parse(rawQueryStringified);
  const { function_score: { query, functions = [] } = {} } = parsedRawQuery;

  const boostedPropsFunctios = recencyBoostProperty.map(propToBoost => ({
    gauss: {
      [propToBoost]: {
        origin: 'now',
        scale: '30d',
        offset: '7d',
        decay: 0.5
      }
    }
  }));

  const updatedData = {
    function_score: {
      query: functions.length ? query : parsedRawQuery,
      functions: [...functions, ...boostedPropsFunctios],
      boost_mode: 'multiply'
    }
  };

  return {
    ...data,
    rawQueryStringified: JSON.stringify(updatedData)
  };
};

export default buildQueryBooster;
